
export const ActivitiesRelationTypesEnum = {
  unit: {
    key: 2,
    value: 'unit',
  },
  lead: {
    key: 3,
    value: 'lead',
  },
  workOrder: {
    key: 1,
    value: 'work-order',
  },
  portfolio: {
    key: 4,
    value: 'portfolio',
  },
  maintenanceContract: {
    key: 5,
    value: 'maintenance-contract',
  },
};
